import type { AccessibleComicTransform } from "../../canvas/canvasTypes";
import type { ComicBubbleObject } from "../../comic/comicTypes";

interface BubbleInspectorProps {
  destructiveAllowed?: boolean;
  object: ComicBubbleObject;
  onDelete: () => void;
  onEdit: () => void;
  onTransform: (change: AccessibleComicTransform) => void;
}

export function BubbleInspector({
  object,
  onDelete,
  onEdit,
  onTransform,
  destructiveAllowed = true,
}: BubbleInspectorProps) {
  return (
    <section className="bubble-inspector" aria-label="Selected dialogue object">
      <div>
        <strong>{object.type === "narrationBox" ? "Narration" : "Bubble"}</strong>
        <span>{object.data.text || "Empty text"}</span>
      </div>
      <div className="bubble-inspector__actions">
        <button onClick={onEdit} type="button">
          Edit text
        </button>
        <button
          aria-label="Make selected bubble smaller"
          onClick={() => onTransform("shrink")}
          type="button"
        >
          Smaller
        </button>
        <button
          aria-label="Make selected bubble bigger"
          onClick={() => onTransform("grow")}
          type="button"
        >
          Bigger
        </button>
        <button
          aria-label="Rotate selected bubble left"
          onClick={() => onTransform("rotate-left")}
          type="button"
        >
          ↶
        </button>
        <button
          aria-label="Rotate selected bubble right"
          onClick={() => onTransform("rotate-right")}
          type="button"
        >
          ↷
        </button>
        <button
          className="bubble-inspector__delete"
          disabled={!destructiveAllowed}
          onClick={onDelete}
          type="button"
        >
          Delete bubble
        </button>
      </div>
    </section>
  );
}
